import Link from "next/link";
import "./index.scss";
import Image from "next/image";

export default function Catering() {
  return (
    <>
      {/* Start Catering */}
      <section id="order" className="catering-area pb-16 pt-6">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex items-center justify-end relative">
            <Link
              href="#home"
              type="button"
              className="catering-order focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-4 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-green-800 inline-flex items-center"
            >
              START YOUR CATERING ORDER
              <svg
                className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9"
                />
              </svg>
            </Link>
            <Image
              width={900}
              height={300}
              className=""
              src="/shared/cateringNationwide2.jpg"
              alt="cateringNationwide2"
            />
          </div>
        </div>
      </section>
    </>
  )
}